const invalidFileNameCharacters = new Set(['<', '>', ':', '"', '/', '\\', '|', '?', '*'])

const sanitizeFileName = (value: string) =>
  value
    .trim()
    .split('')
    .filter((character) => character.charCodeAt(0) >= 32 && !invalidFileNameCharacters.has(character))
    .join('')
    .replace(/\s+/g, ' ')
    .replace(/[. ]+$/g, '')

export const buildPdfFileName = (baseName: string) => {
  const safeName = sanitizeFileName(baseName) || 'report'
  return safeName.toLowerCase().endsWith('.pdf') ? safeName : `${safeName}.pdf`
}

export const buildFileName = (baseName: string, extension: string) => {
  const safeName = sanitizeFileName(baseName) || 'download'
  const normalizedExtension = extension.trim().replace(/^\./, '')
  if (!normalizedExtension) {
    return safeName
  }

  return safeName.toLowerCase().endsWith(`.${normalizedExtension.toLowerCase()}`)
    ? safeName
    : `${safeName}.${normalizedExtension}`
}

// Same base name as the PDF report, plus the download date: "<Project> - <Report> <#>_yyyy-MM-dd.xlsx"
export const buildExcelFileName = (reportBaseName: string, downloadedAt = new Date()) => {
  const pad = (value: number) => String(value).padStart(2, '0')
  const downloadDate = [
    downloadedAt.getFullYear(),
    pad(downloadedAt.getMonth() + 1),
    pad(downloadedAt.getDate()),
  ].join('-')
  return buildFileName(`${reportBaseName}_${downloadDate}`, 'xlsx')
}

export const downloadFile = (blob: Blob, fileName: string) => {
  const objectUrl = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = objectUrl
  anchor.download = fileName
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0)
}

export const downloadBlobAsFile = (blob: Blob, fileName: string) => {
  downloadFile(blob, buildPdfFileName(fileName))
}
